export const headCells = [
    { id: 'plugin_id', numeric: true, disablePadding: true, label: '#' },
    { id: 'name', numeric: false, disablePadding: false, label: 'Плагин' },
    { id: 'provider', numeric: false, disablePadding: false, label: 'Источник' },
    { id: 'version', numeric: false, disablePadding: false, label: 'Версия' },
    { id: 'download_url', numeric: false, disablePadding: false, label: 'Ссылка' },
    { id: 'updated_at', numeric: false, disablePadding: false, label: 'Обновлено' },
    { id: 'status', numeric: false, disablePadding: false, label: 'Статус' }
];

const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
};

export const getComparator = (order, orderBy) => (
    order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy)
);

export const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};
